export const jobList = "JOB_LIST";
export const jobPaymentDetails = "JOB_PAYMENT_DETAILS";